import { faSitemap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function startEnumeration() {
    return (
        <div data-cy="historic-controller-startEnum">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.startEnumeration" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faSitemap} style={{ color: 'green' }} size="lg" />
            </Whisper>
        </div>
    );
}
